/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { InvoicePayPathParams, InvoicePayResponse } from '../types/InvoicePay'

/**
 * POST /:organisation/invoices/:invoice/pay
 * @see backend/nexus/modules/Billing/Http/Controllers/InvoiceController.php InvoiceController::pay
 */
export async function invoicePay(
	organisation: InvoicePayPathParams['organisation'],
	invoice: InvoicePayPathParams['invoice'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<InvoicePayResponse>> {
	return axiosInstance.post(`/${organisation}/invoices/${invoice}/pay`, undefined, config)
}
